<template>
  <AppSingleSelect
    v-model="selectedEvent"
    :options="eventOptions"
    @input="handleSelect"
  ></AppSingleSelect>
</template>

<script>
import { mapState } from 'vuex';
import eventApi from "@/apis/event";
import AppSingleSelect from "@/components/AppSingleSelect.vue";

export default {
  components: { AppSingleSelect },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      eventOptions: [],
      selectedEvent: {},
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.syncSelectedEvent(newVal);
      },
    },
    eventOptions() {
      this.syncSelectedEvent(this.value);
    },
  },
  mounted() {
    this.fetchEvents();
  },
  methods: {
    async fetchEvents() {
      const { data } = await eventApi.getEvents(this.organization, { is_all: true });

      this.eventOptions = [
        { value: null, text: "請選擇活動代碼"},
        { value: "none", text: "品牌組織階層(無活動代碼)" },
        ...data.data.map((event) => {
          return {
            value: event.id,
            text: `(${event.code}) ${event.name}`
          };
        }),
      ];
    },
    syncSelectedEvent(val) {
      this.selectedEvent = this.eventOptions.find(o => o.value == val) || this.eventOptions[0] || {};
    },
    handleSelect(option) {
      this.$emit('input', option?.value ?? null);
      this.$emit('change', option?.value ?? null);
    },
  },
}
</script>
